import { Globals } from "../CoreApp/Globals";

export function hoverTimer() {
  if (Globals._hoverMgr) {
    Globals._hoverMgr.DisplayToolTip();
    Globals._hoverMgr.TimerDone();
  }
}
